import { useState } from "react";

/**
 * Permite realizar validaciones propias de un input 
 * @returns 
 */
export const useInputValidations = () => {
    const onKeyDownRegexp = (regex = /^[a-zA-Z0-9]*$/) => (event) => {
        if (['Backspace', 'Tab'].includes(event.key)) return;
        if (!regex.test(event.key))
            event.preventDefault(); // Evita que el carácter no válido se ingrese
    }
    return { onKeyDownRegexp };
}


export const useInput = () => {
    const [value, setValue] = useState();
    const onChange = (evt) => {
        setValue(evt?.target?.value??'')
    }
    return { value, setValue, bind: { onChange, value } }
}